/** @format */

import { Component, HostBinding, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: `a[homefield-product-title]`,
  templateUrl: './product-title.component.html',
  styleUrl: './product-title.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HomefieldProductTitleComponent {
  @HostBinding('attr.href') @Input() linkURL = '';
  @HostBinding('attr.data-em') @Input() dataEm = null;
  @HostBinding('attr.title') @Input() title = null;
  @HostBinding('attr.aria-label') @Input() ariaLabel = null;
}
